import React from "react";
import { Link } from "react-router-dom";
import Logo from "../../../Assets/Images/company_logo.png";
import "./videobanner.css";

// import pdf from "../../../Assets/Pdf/shootinschoolbookFINAL_sml-1.pdf";

{
  /* <iframe width="560" height="315" src="https://www.youtube.com/embed/4L_RvsGYgF4?si=h_nvt3w9AoaAe4zK" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe> */
}

const VideoBanner = ({
  videoUrl = "https://www.youtube.com/embed/4L_RvsGYgF4?si=h_nvt3w9AoaAe4zK",
  heading = "Team Workouts Are The Advantage Every Team Needs!",
  buttonText = "Register Now",
  buttonLink = "/packages/4",
}) => {
  return (
    <div className="video-banner brightness">
      <div className="vb-content">
        {/* LEFT — VIDEO */}
        <div className="vb-video">
          <iframe
            src={videoUrl}
            title="Team Workout Video"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>

        {/* RIGHT — LOGO + TITLE + BUTTON */}
        <div className="vb-right">
          <img src={Logo} alt="Company Logo" className="vb-logo" />

          <h2 className="vb-title">{heading}</h2>

          {buttonText === "Download Our “About Us” Ebook" ? (
            <>
              <a href={buttonLink} className="vb-btn" download>
                <span className="text-clip">{buttonText}</span>
              </a>
            </>
          ) : (
            <>
              <Link to={buttonLink} className="vb-btn">
                <span className="text-clip">{buttonText}</span>
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default VideoBanner;
